var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttons",class:{
    open: _vm.Open,
  }},_vm._l((_vm.Buttons),function(Button,ButtonIndex){return _c('div',{staticClass:"buttons__item",class:{
      active:
        _vm.Content == Button.cod || (Button.cod == 'comparador' && _vm.Comparador),
    },on:{"click":function($event){return _vm.SetContent(Button)}}},[_c('div',{staticClass:"buttons__item__miniatura"},[_c('img',{staticClass:"buttons__item__miniatura__image",attrs:{"src":require('@/assets/Images/' + Button.miniatura),"alt":""}})]),_c('p',{staticClass:"buttons__item__text"},[_vm._v(" "+_vm._s(Button.literales[ Button.literales.findIndex( (Literal) => Literal.codIdioma == _vm.Language ) ].texto)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }